"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dialogSortingFn = function (a, b) {
    var _a, _b, _c, _d;
    return (((_b = (_a = b.last_message_full) === null || _a === void 0 ? void 0 : _a.date_sent) !== null && _b !== void 0 ? _b : 0) -
        ((_d = (_c = a.last_message_full) === null || _c === void 0 ? void 0 : _c.date_sent) !== null && _d !== void 0 ? _d : 0));
};
exports.default = (function (dialogs) {
    return dialogs.sort(dialogSortingFn);
});
//# sourceMappingURL=sortingDialogs.js.map